import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ProjectCard = ({ project }) => {
  return (
    <div className="group bg-card rounded-xl overflow-hidden border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={project?.image}
          alt={project?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-4 right-4 flex gap-2">
          {project?.featured && (
            <span className="px-3 py-1 rounded-full text-xs font-bold bg-primary text-primary-foreground">
              Featured
            </span>
          )}
          {project?.isNew && (
            <span className="px-3 py-1 rounded-full text-xs font-bold bg-success text-success-foreground">
              New
            </span>
          )}
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex-1 min-w-0">
            <h3 className="text-lg md:text-xl font-bold font-heading text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors duration-300">
              {project?.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
              {project?.description}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-4 flex-wrap">
          <span className="px-2 py-1 rounded text-xs font-medium bg-muted text-muted-foreground">
            {project?.industry}
          </span>
          <span className="px-2 py-1 rounded text-xs font-medium bg-muted text-muted-foreground">
            {project?.type}
          </span>
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          {project?.technologies?.slice(0, 4)?.map((tech, index) => (
            <span
              key={index}
              className="px-2 py-1 rounded text-xs font-medium bg-primary/10 text-primary"
            >
              {tech}
            </span>
          ))}
          {project?.technologies?.length > 4 && (
            <span className="px-2 py-1 rounded text-xs font-medium text-muted-foreground">
              +{project?.technologies?.length - 4}
            </span>
          )}
        </div>

        <div className="grid grid-cols-3 gap-3 mb-4 pb-4 border-b border-border">
          {project?.metrics?.map((metric, index) => (
            <div key={index} className="text-center">
              <div className="text-lg md:text-xl font-bold text-primary whitespace-nowrap">
                {metric?.value}
              </div>
              <div className="text-xs text-muted-foreground line-clamp-2">
                {metric?.label}
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{project?.year}</span>
          </div>
          <div className="flex items-center gap-2">
            {project?.liveUrl && (
              <a
                href={project?.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-300 flex items-center gap-1"
                aria-label="View live project"
              >
                <Icon name="ExternalLink" size={16} />
                <span className="text-xs font-medium">view Project</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;